// Gerenciamento do modo de simulação (Impersonation) para o Administrador
import axios from "axios";

export const isImpersonating = () => {
  try {
    const raw = localStorage.getItem("adminImpersonation");
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return Boolean(parsed && parsed.isImpersonating);
  } catch {
    return false;
  }
};

export const getImpersonationData = () => {
  try {
    const raw = localStorage.getItem("adminImpersonation");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const startImpersonation = async (atleta, targetPath = "/ar/shop") => {
  if (!atleta) return;

  const currentAdminToken =
    localStorage.getItem("token") || localStorage.getItem("tokenAcesso");
  const currentAdminUser = localStorage.getItem("user");
  const existingImpersonation = getImpersonationData();

  // Preserva os dados originais do admin mesmo se encadear simulações
  const originalToken = existingImpersonation?.adminToken || currentAdminToken;
  const originalUser = existingImpersonation?.adminUser || currentAdminUser;
  const athleteId = atleta._id || atleta.id;

  // Rota atual para onde o admin deve retornar ao encerrar
  const currentPath = window.location.hash
    ? window.location.hash.replace("#", "")
    : window.location.pathname;

  const impersonationData = {
    isImpersonating: true,
    adminToken: originalToken,
    adminUser: originalUser,
    athleteId,
    athleteName: atleta.nome,
    returnUrl: currentPath.startsWith("/ar") ? "/admin/atletas" : currentPath,
    startedAt: new Date().toISOString(),
  };

  localStorage.setItem("adminImpersonation", JSON.stringify(impersonationData));

  // Remove o token do admin de 'token' para que componentes não considerem o usuário como Admin
  localStorage.removeItem("token");

  // Configura os dados do atleta no localStorage como o usuário ativo
  let simulatedUser = {
    id: athleteId,
    _id: athleteId,
    nome: atleta.nome,
    perfil: atleta.perfil || "Atleta",
    celular: atleta.celular ? String(atleta.celular) : "",
    chaveAcesso: atleta.chaveAcesso || "",
    atletasRepresentados: Array.isArray(atleta.atletasRepresentados)
      ? atleta.atletasRepresentados
      : [],
    idioma: atleta.idioma || "pt",
  };

  // Solicita um token de simulação oficial do backend com perfil de atleta
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/auth/impersonate`,
      { athleteId },
      {
        headers: {
          Authorization: `Bearer ${originalToken}`,
        },
      }
    );

    if (response.data?.token) {
      localStorage.setItem("tokenAcesso", response.data.token);
      if (response.data.user) {
        simulatedUser = { ...simulatedUser, ...response.data.user };
      }
    } else {
      localStorage.setItem("tokenAcesso", originalToken);
    }
  } catch (err) {
    console.warn("Simulação via endpoint falhou, usando fallback com token de acesso:", err);
    localStorage.setItem("tokenAcesso", originalToken);
  }

  localStorage.setItem("user", JSON.stringify(simulatedUser));

  // Notifica componentes e navega
  window.dispatchEvent(new Event("impersonation-change"));
  const cleanTarget = targetPath.startsWith("/") ? targetPath : `/${targetPath}`;
  window.location.href = `/#${cleanTarget}`;
};

export const stopImpersonation = () => {
  const impData = getImpersonationData();
  let returnUrl = "/admin/atletas";

  if (impData) {
    if (impData.returnUrl) returnUrl = impData.returnUrl;
    if (impData.adminToken) {
      localStorage.setItem("token", impData.adminToken);
    }
    if (impData.adminUser) {
      localStorage.setItem(
        "user",
        typeof impData.adminUser === "string"
          ? impData.adminUser
          : JSON.stringify(impData.adminUser)
      );
    } else {
      localStorage.removeItem("user");
    }
  }

  localStorage.removeItem("adminImpersonation");
  localStorage.removeItem("tokenAcesso");

  window.dispatchEvent(new Event("impersonation-change"));
  const cleanReturn = returnUrl.startsWith("/") ? returnUrl : `/${returnUrl}`;
  window.location.href = `/#${cleanReturn}`;
};

